import { useEffect, useState } from "react";
import { ArrowUp, Send } from "lucide-react";
import api from "@/lib/api";

/** Icône officielle WhatsApp (SVG vectoriel, couleur héritée) */
function WhatsAppIcon({ className = "w-6 h-6" }) {
  return (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.03-.53-.03-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.828 1.23 1.99 2.606 3.593 4.68 4.826.42.257 3.087 1.44 3.387 1.44.53 0 2.635-.66 2.65-1.663v-.014c0-.115-.03-.214-.06-.315-.216-.372-1.834-1.13-2.207-1.318-.156-.086-.343-.157-.53-.157zm-2.978 7.14a10.68 10.68 0 0 1-3.437-.545c-.156-.058-.315-.086-.487-.086-.415 0-.83.116-1.203.244l-2.05.674.673-2.006a1.62 1.62 0 0 0 .114-.573c0-.187-.03-.372-.087-.545a10.63 10.63 0 0 1-.688-3.71c0-5.847 4.767-10.614 10.615-10.614 5.85 0 10.615 4.767 10.615 10.614 0 5.85-4.767 10.615-10.615 10.615zm0-23.31a12.68 12.68 0 0 0-12.68 12.68c0 1.35.216 2.685.617 3.965l-1.633 4.855a.62.62 0 0 0-.045.244.68.68 0 0 0 .687.686c.086 0 .187-.014.272-.045l5.043-1.603a12.66 12.66 0 0 0 3.723.56c7.028 0 12.732-5.706 12.732-12.68 0-6.976-5.647-12.68-12.68-12.68z" />
    </svg>
  );
}

export default function FloatingActions() {
  const [show, setShow] = useState(false);
  const [whatsapp, setWhatsapp] = useState("");
  const [telegram, setTelegram] = useState("");

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    api.get("/site").then((r) => {
      setWhatsapp(r.data.whatsapp || "");
      setTelegram(r.data.telegram || "");
    }).catch(() => {});
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const waHref = whatsapp
    ? `https://wa.me/${whatsapp.replace(/[^\d]/g, "")}?text=${encodeURIComponent(
        "Bonjour KV International, je suis intéressé par l'un de vos modèles de prestige."
      )}`
    : null;

  const tgHref = telegram
    ? `https://t.me/${telegram.replace(/^@/, "").trim()}`
    : null;

  return (
    <div
      className="fixed z-40 flex flex-col gap-2.5 sm:gap-3 bottom-4 right-4 sm:bottom-6 sm:right-6"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      {show && (
        <button
          data-testid="back-to-top"
          onClick={toTop}
          aria-label="Retour en haut"
          className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-[#1E1E1E] border border-white/10 hover:border-[#C8A75A] flex items-center justify-center text-white/70 hover:text-[#C8A75A] transition-colors shadow-[0_8px_32px_rgba(0,0,0,0.4)]"
        >
          <ArrowUp className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
        </button>
      )}
      {tgHref && (
        <a
          href={tgHref}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="telegram-float"
          aria-label="Contacter sur Telegram"
          className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#229ED9] hover:bg-[#1a89bf] flex items-center justify-center text-white shadow-[0_8px_32px_rgba(34,158,217,0.35)] transition-colors"
        >
          <Send className="w-5 h-5 sm:w-6 sm:h-6" />
        </a>
      )}
      {waHref && (
        <a
          href={waHref}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="whatsapp-float"
          aria-label="Contacter KV International sur WhatsApp"
          title="Contacter KV International sur WhatsApp"
          className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#25D366] hover:bg-[#20b757] flex items-center justify-center text-white shadow-[0_8px_32px_rgba(37,211,102,0.45)] transition-transform hover:scale-105 active:scale-95"
        >
          <WhatsAppIcon className="w-6 h-6 sm:w-7 sm:h-7" />
        </a>
      )}
    </div>
  );
}
